{
  "addButtonLabel": "Fa’agasologa poʻo se taotoga",
  "date": "Aso",
  "datePlaceholder": "e.g. June 2022, 2021, or ~5 years ago",
  "location": "Nofoaga",
  "locationPlaceholder": "e.g. Ormiston Hospital, Auckland",
  "nextLabel": "$t(common:next): <b>Gaoioiga o le tino</b>",
  "procedure": "Fa’amatalaga o le taotoga po’o le togafitiga",
  "procedurePlaceholder": "Fa’amolemole tusi i le gagana Peretania. Fa’ata’ita’iga: <br/>\nColonoscopy to investigate bleeding",
  "saveButton": "Sefe taotoga",
  "text": "<p>O lo'o iai le fa'amaumauga o lau endoscopy talu ai i le {{company}}:</p>\n<ul><li><strong>{{procedure}}</strong> i le <strong>{{date}}</strong></li></ul>\n<p>Ua e faia se isi endoscopy, taotoga o le manava, po'o se isi taotoga tetele talu mai lenā?</p>",
  "textNoProcedure": "Na e faia muamua se endoscopy, taotoga o le manava, po’o se isi taotoga tetele?",
  "title": "Taotoga poʻo ni togafitiga lata mai"
}
